import { render, staticRenderFns } from "./ModifierTasteSelects.vue?vue&type=template&id=11d6ea12&"
import script from "./ModifierTasteSelects.vue?vue&type=script&lang=js&"
export * from "./ModifierTasteSelects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports